import {
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_DEFINITIONS,
  isNotificationOn,
  type ModuleState,
  type NotificationCategory,
} from '@nest-recruit/shared';

/**
 * R1 (§L28): a category whose every message belongs to a switched-off module has nothing in it —
 * no setting on NOTIF-02, no choice in NOTIF-01's Category picker. It comes back with the module.
 */
export function isCategoryLive(category: NotificationCategory, modules: ModuleState): boolean {
  return NOTIFICATION_DEFINITIONS.some(
    (definition) => definition.category === category && isNotificationOn(modules, definition.key),
  );
}

export function liveCategories(modules: ModuleState): readonly NotificationCategory[] {
  return NOTIFICATION_CATEGORIES.filter((category) => isCategoryLive(category, modules));
}
